import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e5a0a458")

_pushScopeId("data-v-e5a0a458")
const _hoisted_1 = { class: "main-panel flex-grow flex flex-col" }
const _hoisted_2 = { class: "flex-grow flex flex-col px-4 pt-6 overflow-y-scroll" }
const _hoisted_3 = { class: "flex flex-col mb-8" }
const _hoisted_4 = { class: "flex mb-4" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h3", { class: "font-medium text-lg" }, "提出状況", -1)
const _hoisted_6 = { class: "flex items-center ml-3" }
const _hoisted_7 = { class: "px-1 hidden lg:flex text-gray-400" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "text-gray-600 hidden lg:inline pr-4" }, "表示終了日が過ぎた提出物を表示", -1)
const _hoisted_9 = {
  key: 0,
  class: "flex justify-center py-4"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "さらに読み込む", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MSPanelHeader = _resolveComponent("MSPanelHeader")
  const _component_SubmissionCard = _resolveComponent("SubmissionCard")
  const _component_ThreadCard = _resolveComponent("ThreadCard")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_MSPanelHeader, {
      "select-page": "submissions",
      onOpen: _ctx.open
    }, null, 8, ["onOpen"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("section", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              _createVNode("label", _hoisted_7, [
                _createVNode("input", {
                  type: "checkbox",
                  name: "select",
                  class: "cursor-pointer",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeShowDisplayEndDateFlag()))
                }, null, 32)
              ]),
              _hoisted_8
            ])
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredSubmissionsForCard, (dataMap) => {
            return (_openBlock(), _createBlock(_component_SubmissionCard, {
              key: dataMap.data.id,
              title: dataMap.submissionMasterData.name,
              label: dataMap.submissionMasterData.label,
              closedAt: dataMap.data.closedAt,
              checkedAt: dataMap.data.checkedAt,
              submittableFrom: dataMap.data.submittableFrom,
              displayEndAt: dataMap.data.displayEndAt,
              status: dataMap.data.status,
              submissionMasterId: dataMap.submissionMasterRef.id,
              submissionId: dataMap.ref.id,
              onConfirm: ($event: any) => (_ctx.confirm(dataMap)),
              class: "mb-4"
            }, null, 8, ["title", "label", "closedAt", "checkedAt", "submittableFrom", "displayEndAt", "status", "submissionMasterId", "submissionId", "onConfirm"]))
          }), 128)),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredThreadsForCard, (thread) => {
            return (_openBlock(), _createBlock(_component_ThreadCard, {
              key: thread.data.id,
              title: thread.threadMasterData.name,
              label: thread.threadMasterData.label,
              posts: thread.data.posts,
              submittableFrom: thread.threadMasterData.submittableFrom,
              displayEndAt: thread.threadMasterData.displayEndAt,
              threadMasterId: thread.threadMasterRef.id,
              threadId: thread.ref.id,
              onConfirm: ($event: any) => (_ctx.confirm(thread)),
              class: "mb-4"
            }, null, 8, ["title", "label", "posts", "submittableFrom", "displayEndAt", "threadMasterId", "threadId", "onConfirm"]))
          }), 128)),
          (!_ctx.allSubmissionsFetched)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode("div", {
                  class: "px-4 py-2 rounded-md text-gray-700 text-sm underline transition-colors duration-300 cursor-pointer hover:bg-gray-100",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getMoreSubmission && _ctx.getMoreSubmission(...args)))
                }, [
                  _hoisted_10
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
})